import React from 'react';
import { ROUTES } from 'Navigation';
import { SubRoutesContainer } from 'Features/Shared';

export const OpenReferralsCommercialMain: React.FC = () => {
  return <SubRoutesContainer route={ROUTES.COMMERCIAL} />;
};
